import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { EventBusService } from '@at/shared';
import { DisplayNameComponent } from '../display-name/display-name.component';
import { User } from '../../entities';
import { CdkMenu, CdkMenuItem } from '@angular/cdk/menu';

@Component({
  selector: 'at-user-menu',
  standalone: true,
  imports: [RouterLink, DisplayNameComponent, RouterLinkActive, CdkMenu, CdkMenuItem],
  templateUrl: './user-menu.component.html',
  styleUrl: './user-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserMenuComponent {
  private readonly eventBusService = inject(EventBusService);

  readonly user = input.required<User>();

  protected logout(): void {
    this.eventBusService.emit({ name: 'logout', value: null });
  }
}
